import { useDispatch, useSelector } from 'react-redux';
import { useMemo } from 'react';
import { RootState } from '../redux/rootReducer';
import { fetchBundle } from '../redux/slices/bundle';
import { TableHeaderCell } from '../@types/tableRows';

// ----------------------------------------------------------------------

function useBundle() {
  const dispatch = useDispatch();
  const { response, APIStatus, error } = useSelector(
    (state: RootState) => state.bundle
  );

  const summary: Array<TableHeaderCell> =
    useMemo((): Array<TableHeaderCell> => {
      const qty = response.rows.map((r) => r.qty).reduce((a, b) => a + b, 0);
      const purchasePrice = response.rows
        .map((r) => r.purchasePrice)
        .reduce((a, b) => a + b, 0);
      const total = response.rows
        .map((r) => r.total)
        .reduce((a, b) => a + b, 0);
      return [
        {
          id: 0,
          field: 'variationId',
          label: 'bundle_variationId',
          align: 'center',
          summary: {
            value: 0,
            type: 'no'
          }
        },
        {
          id: 1,
          field: 'name',
          label: 'bundle_name',
          align: 'center',
          canSort: false,
          summary: {
            value: 0,
            type: 'no'
          }
        },
        {
          id: 2,
          field: 'ean',
          label: 'bundle_ean',
          align: 'center',
          canSort: false,
          summary: {
            value: 0,
            type: 'no'
          }
        },
        {
          id: 3,
          field: 'asin',
          label: 'bundle_asin',
          align: 'center',
          canSort: false,
          summary: {
            value: 0,
            type: 'no'
          }
        },
        {
          id: 4,
          field: 'sku',
          label: 'bundle_sku',
          align: 'center',
          canSort: false,
          summary: {
            value: 0,
            type: 'no'
          }
        },
        {
          id: 5,
          field: 'qty',
          label: 'bundle_qty',
          align: 'center',
          canSort: false,
          summary: {
            value: qty,
            type: 'qty',
            align: 'center',
            paddingRight: '8px',
            calculation: 'sum'
          }
        },
        {
          id: 6,
          field: 'purchasePrice',
          label: 'bundle_purchasePrice',
          align: 'center',
          canSort: false,
          summary: {
            value: purchasePrice,
            type: 'currency',
            align: 'center',
            paddingRight: '8px',
            calculation: 'sum'
          }
        },
        {
          id: 7,
          field: 'total',
          label: 'bundle_total',
          align: 'center',
          canSort: false,
          summary: {
            value: total,
            type: 'currency',
            align: 'center',
            paddingRight: '8px',
            calculation: 'sum'
          }
        }
      ];
    }, [response]);

  return {
    summary,
    response,
    APIStatus,
    error,
    getBundle: (articleId: number) => dispatch(fetchBundle(articleId))
  };
}

export default useBundle;
